<template>
  <div class="base_box">
    <div class="base_form base_form_padding base_form_height">
      <div class="base_form_title">基础设置</div>
      <el-form
        class="mt20 ml20 lable-form"
        ref="form"
        :model="post"
        :rules="rules"
        label-width="120px"
        style="margin-bottom: 16px"
        hide-required-asterisk
      >
        <!-- 是否开启 -->
        <el-form-item label="是否开启">
          <el-radio-group size="small" v-model="post.is_open">
            <el-radio label="1" style="margin-right: 12px">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
          <div class="base_tips">开启后会员端"我的"页面会显示分红按钮，关闭则不显示，并且该功能直接关闭。</div>
        </el-form-item>

        <!-- 总池子比例 -->
        <el-form-item label="总池子比例" prop="poolprofit_rate">
          <el-input size="small" v-model="post.poolprofit_rate" type="number" style="width: 150px">
            <template slot="append">%</template>
          </el-input>
          <div class="base_tips">按照每笔订单的百分比进行分红入总池，示例：29800*10%=2980，那么总池子有2980.00元。</div>
        </el-form-item>

        <!-- 店长池子 -->
        <el-form-item label="店长池子" prop="keeper_rate">
          <el-input size="small" v-model="post.keeper_rate" type="number" style="width: 150px">
            <template slot="append">%</template>
          </el-input>
          <div class="base_tips">按照总池子进行分配百分比，加入总池子2980，那么店长池子2980*50%=1490，由所有店长平分这个钱。</div>
        </el-form-item>

        <!-- 合伙人池子 -->
        <el-form-item label="合伙人池子" prop="partner_rate">
          <el-input size="small" v-model="post.partner_rate" type="number" style="width: 150px">
            <template slot="append">%</template>
          </el-input>
          <div class="base_tips">按照总池子进行分配百分比，加入总池子2980，那么合伙人池子2980*50%=1490，由所有合伙人平分这个钱。</div>
        </el-form-item>

        <!-- 分红条件 -->
        <el-form-item label="分红条件" prop="bonus_settle_stage">
          <el-radio-group size="small" v-model="post.bonus_settle_stage">
            <el-radio label="1" style="margin-right: 12px">付款后</el-radio>
            <el-radio label="2">订单完成</el-radio>
          </el-radio-group>
          <div class="base_tips">【付款后】即会员完成交易支付即开始计算返现金额，相当于预付款后7天后订单进行返现入账；</div>
          <div class="base_tips">【订单完成】即确认收货且物流签收且无售后纠纷后，系统开始计算订单返现金额。</div>
        </el-form-item>

        <!-- 分红周期 -->
        <el-form-item label="分红周期" prop="bonus_cycle_days">
          <el-input size="small" v-model="post.bonus_cycle_days" type="number" style="width: 150px">
            <template slot="append">天</template>
          </el-input>
          <div class="base_tips">订单确认收货后，延迟指定天数后到账。</div>
        </el-form-item>

        <!-- 分红权益 -->
        <el-form-item label="分红权益">
          <el-button size="small" type="primary" plain @click="editorVisible = true">点击设置</el-button>
          <div class="base_tips">可上传图文信息，作为模式讲解或协议条款。</div>
        </el-form-item>
      </el-form>

      <div class="base_form_title nml15">结算设置</div>
      <el-form
        class="mt20 ml20 lable-form"
        ref="form2"
        :model="post"
        :rules="rules"
        label-width="120px"
        style="margin-bottom: 16px"
        hide-required-asterisk
      >
        <!-- 单笔提现 -->
        <el-form-item label="单笔提现" prop="min_withdrawal">
          <div class="flex_align">
            <span class="input-text_left">最低</span>
            <el-input size="small" v-model="post.min_withdrawal" type="number" style="width: 120px; margin: 0 8px">
              <template slot="append">元</template>
            </el-input>
            <span class="input-text_left">最高</span>
            <el-input size="small" v-model="post.max_withdrawal" type="number" style="width: 120px; margin: 0 8px">
              <template slot="append">元</template>
            </el-input>
          </div>
          <div class="base_tips">0代表不限制，不可为空。</div>
        </el-form-item>

        <!-- 每日提现限额 -->
        <el-form-item label="每日提现限额" prop="day_withdrawal">
          <el-input size="small" v-model="post.day_withdrawal" type="number" style="width: 150px">
            <template slot="append">元</template>
          </el-input>
          <div class="base_tips">0代表不限制，不可为空。</div>
        </el-form-item>

        <!-- 提现费率 -->
        <el-form-item label="提现费率" prop="service_charge">
          <el-input size="small" v-model="post.service_charge" type="number" style="width: 150px">
            <template slot="append">%</template>
          </el-input>
          <div class="base_tips">返佣申请提现扣除手续费比例，例如：100，扣除3%，用户实际到账97元。</div>
        </el-form-item>

        <!-- 免手续费 -->
        <el-form-item label="免手续费" prop="min">
          <div class="flex_align">
            <el-input size="small" v-model="post.min" type="number" style="width: 120px">
              <template slot="append">元</template>
            </el-input>
            <span class="input-text_left" style="margin: 0 8px">至</span>
            <el-input size="small" v-model="post.max" type="number" style="width: 120px">
              <template slot="append">元</template>
            </el-input>
          </div>
          <div class="base_tips">当设置了免手续费区间，用户发起提现金额在免手续费区间范围内，则不扣除提现手续费。</div>
          <div class="base_tips">区间 0~0 代表不开启免手续费政策。</div>
        </el-form-item>

        <!-- 提现审核 -->
        <el-form-item label="提现审核" prop="exam_type">
          <el-radio-group size="small" v-model="post.exam_type">
            <el-radio label="1" style="margin-right: 12px">手动审核</el-radio>
            <el-radio label="0">自动审核</el-radio>
          </el-radio-group>
          <div class="base_tips">用户申请提现后可选择手动审核和系统自动审核，审核通过后才能进行提现打款。</div>
        </el-form-item>

        <!-- 自动打款 -->
        <el-form-item label="自动打款" prop="remit_type">
          <el-radio-group size="small" v-model="post.remit_type">
            <el-radio label="1" style="margin-right: 12px">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
          <div class="base_tips">提现审核通过后将自动打款。</div>
        </el-form-item>

        <!-- 提现方式 -->
        <el-form-item label="提现方式">
          <el-checkbox
            true-label="1"
            false-label="0"
            v-model="post.withdrawal_to_balance"
            style="margin-right: 15px"
          >提现到商城余额</el-checkbox>
          <el-checkbox
            true-label="1"
            false-label="0"
            v-model="post.withdrawal_to_wx"
            style="margin-right: 15px"
          >提现到微信钱包</el-checkbox>
          <el-checkbox
            true-label="1"
            false-label="0"
            v-model="post.withdrawal_to_ali"
            style="margin-right: 15px"
          >提现到支付宝</el-checkbox>
          <el-checkbox
            true-label="1"
            false-label="0"
            v-model="post.withdrawal_to_bank"
          >提现到银行卡</el-checkbox>
          <div class="base_tips">选择用户可使用的提现方式。</div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 保存按钮 -->
    <div class="base_fixed_bottom">
      <el-button class="base_but_style base_save_but" type="primary" @click="submitForm">保存</el-button>
    </div>

    <!-- 富文本弹窗 -->
    <el-dialog title="分红权益说明" :visible.sync="editorVisible" width="800px" :close-on-click-modal="false">
      <TinymceEditor v-model="post.content" :height="400" />
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editorVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="editorVisible = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { eltips } from "@/util/util.js";
import { jsonToFormData } from "@/util/weishop/format";
import TinymceEditor from "@/components/TinymceEditor/TinymceEditor";

export default {
  components: {
    TinymceEditor,
  },
  data() {
    return {
      editorVisible: false,
      post: {
        is_open: "1",
        poolprofit_rate: "",
        keeper_rate: "",
        partner_rate: "",
        bonus_settle_stage: "2",
        bonus_cycle_days: "",
        content: "",
        min_withdrawal: "",
        max_withdrawal: "",
        day_withdrawal: "",
        service_charge: "",
        min: "",
        max: "",
        exam_type: "0",
        remit_type: "1",
        withdrawal_to_balance: "0",
        withdrawal_to_wx: "1",
        withdrawal_to_ali: "0",
        withdrawal_to_bank: "0",
      },
      rules: {
        poolprofit_rate: [{ required: true, message: "请输入总池子比例", trigger: "blur" }],
        keeper_rate: [{ required: true, message: "请输入店长池子比例", trigger: "blur" }],
        partner_rate: [{ required: true, message: "请输入合伙人池子比例", trigger: "blur" }],
        bonus_settle_stage: [{ required: true, message: "请选择分红条件", trigger: "change" }],
        bonus_cycle_days: [{ required: true, message: "请输入分红周期", trigger: "blur" }],
        min_withdrawal: [{ required: true, message: "请输入单笔提现最低金额", trigger: "blur" }],
        max_withdrawal: [{ required: true, message: "请输入单笔提现最高金额", trigger: "blur" }],
        day_withdrawal: [{ required: true, message: "请输入每日提现限额", trigger: "blur" }],
        service_charge: [{ required: true, message: "请输入提现费率", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getInit();
  },
  methods: {
    getInit() {
      let _this = this;
      _this.axios
        .get("/api/weishop/admin/setting/detail?key=poolprofit")
        .then((res) => {
          if (res.code == 200) {
            if (res.data) {
              _this.post = { ..._this.post, ...res.data };
            }
          } else {
            eltips(res.msg, "error");
          }
        });
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.$refs.form2) {
            this.$refs.form2.validate((valid2) => {
              if (valid2) {
                this.sendinfo();
              } else {
                return false;
              }
            });
          } else {
            this.sendinfo();
          }
        } else {
          return false;
        }
      });
    },
    sendinfo() {
      let _this = this;
      let url = "/api/weishop/admin/setting/update";

      this.axios
        .post(url, jsonToFormData({ form: this.post, key: "poolprofit" }), {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res.code == 200) {
            _this.getInit();
            eltips(res.msg, "success");
          } else {
            eltips(res.msg, "error");
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.ml20 {
  margin-left: 20px;
}
.nml15 {
  margin-left: -15px;
}
.flex_align {
  display: flex;
  align-items: center;
}
.input-text_left {
  color: #606266;
  font-size: 13px;
}
.base_tips {
  color: #999;
  font-size: 12px;
  line-height: 1.6;
}
::v-deep .el-form-item__label {
  line-height: 34px;
}
::v-deep .el-input-group__append {
  padding: 0 10px;
}
</style>
